
import SearchContent from '../Home/SearchContent'

const Search = () => {
  return (
    <div className=' px-5 py-[80px] w-full h-screen overflow-y-scroll'><SearchContent/></div>
  )
}

export default Search